export class Coverage {
  completed = false;
  insurances = [];
  constructor() {
    this.insurances = this._initCoverage();
  }

  private _initCoverage() {
    return [
      {
        key: 'healthInsurances',
        text: 'Health Insurance(s)',
        subText: '',
        isShownSubText: false,
        actived: false,
        indexOfChosenPolicy: 0,
        newPolicyDefaultOptions: ['typeOfInsurance', 'totalSumInsured', 'renewableDate'],
        addedPolicyDefaultOptions: [
          'typeOfInsurance',
          'totalSumInsured',
          'renewableDate'
        ],
        products: [
          { key: 'health', text: 'Health', actived: false },
          { key: 'criticalIllness', text: 'Critical Illness', actived: false }
        ],
        productCategory: [
          { key: 'healthInsurance', productKey: 'health', value: 'Health Insurance' },
          { key: 'healthInsurance', productKey: 'criticalIllness', value: 'Health Insurance' },
        ],
        questionRaws: [
          {
            key: 'typeOfInsurance',
            label: 'Type Of Insurance',
            order: 1,
            required: true,
            controlType: 'dropdown',
            options: [
              { key: 'hopitalCashPlan', value: 'Hospital Cash plan', miValue: 1 },
              { key: 'criticalIllness', value: 'Critical Illness', miValue: 2 },
              { key: 'outPatient', value: 'Outpatient', miValue: 3 },
              { key: 'hopitalSurgical', value: 'Hospital & Surgical', miValue: 4 },
              { key: 'others', value: 'Others', miValue: 5 }
            ]
          },
          {
            key: 'totalSumInsured',
            label: 'Total Sum Insured',
            order: 2,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'renewableDate',
            label: 'Renewable Date',
            order: 3,
            required: false,
            controlType: 'textbox',
            type: 'date'
          },
          {
            key: 'medicalExpensesAccident',
            label: 'Medical expenses - Accident',
            order: 4,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'medicalExpensesOther',
            label: 'Medical Expenses - Other',
            order: 5,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredAccidentalPermanentDisablement',
            label: 'Sum Insured - Accidental Permanent disablement',
            order: 6,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredAccidentalDeath',
            label: 'Sum Insured - Accidental Death',
            order: 7,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredEarlyCriticalIllness',
            label: 'Sum Insured - Early Critical Illness',
            order: 8,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredCriticalIllness',
            label: 'Sum Insured -  Critical Illness',
            order: 9,
            required: false,
            controlType: 'textbox',
            type: 'number'
          }
        ],
        policies: []
      },
      {
        key: 'PAInsurances',
        text: 'PA Insurance(s)',
        subText: '',
        isShownSubText: false,
        actived: false,
        indexOfChosenPolicy: 0,
        newPolicyDefaultOptions: ['typeOfInsurance', 'totalSumInsured', 'renewableDate'],
        addedPolicyDefaultOptions: [
          'typeOfInsurance',
          'totalSumInsured',
          'renewableDate'
        ],
        products: [{ key: 'personalAccident', text: 'Personal Accident', actived: false }],
        productCategory: [{ key: 'PAInsurance', productKey: 'personalAccident', value: 'Personal Accident Insurance' }],
        questionRaws: [
          {
            key: 'typeOfInsurance',
            label: 'Type Of Insurance',
            order: 1,
            required: true,
            controlType: 'dropdown',
            options: [
              { key: 'comprehensive', value: 'Comprehensive', miValue: 1 },
              { key: 'death', value: 'Death', miValue: 2 },
              { key: 'medicalExpenses', value: 'Medical Expenses', miValue: 3 },
              { key: 'disablement', value: 'Disablement', miValue: 4 },
              { key: 'others', value: 'Others', miValue: 5 }
            ]
          },
          {
            key: 'totalSumInsured',
            label: 'Total Sum Insured',
            order: 2,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'renewableDate',
            label: 'Renewable Date',
            order: 3,
            required: false,
            controlType: 'textbox',
            type: 'date'
          },
          {
            key: 'medicalExpensesAccident',
            label: 'Medical expenses - Accident',
            order: 4,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'medicalExpensesOther',
            label: 'Medical Expenses - Other',
            order: 5,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredAccidentalPermanentDisablement',
            label: 'Sum Insured - Accidental Permanent disablement',
            order: 6,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredAccidentalDeath',
            label: 'Sum Insured - Accidental Death',
            order: 7,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredEarlyCriticalIllness',
            label: 'Sum Insured - Early Critical Illness',
            order: 8,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredCriticalIllness',
            label: 'Sum Insured -  Critical Illness',
            order: 9,
            required: false,
            controlType: 'textbox',
            type: 'number'
          }
        ],
        policies: []
      },
      {
        key: 'assetInsurances',
        text: 'Asset Insurance(s)',
        subText: 'Asset Protection (Motor, Property...)',
        isShownSubText: true,
        actived: false,
        indexOfChosenPolicy: 0,
        newPolicyDefaultOptions: [
          'typeOfAsset',
          'typeOfInsurance',
          'renewableDate',
          'premium'
        ],
        addedPolicyDefaultOptions: ['typeOfInsurance', 'renewableDate', 'premium'],
        products: [
          { key: 'motor', text: 'Motor', actived: false },
          { key: 'property', text: 'Property', actived: false }
        ],
        productCategory: [
          { key: 'motorInsurance', productKey: 'motor', value: 'Motor Insurance' },
          { key: 'housingInsurance', productKey: 'property', value: 'Property Insurance' },
        ],
        questionRaws: [
          {
            key: 'typeOfAsset',
            label: 'Type of asset',
            order: 1,
            required: true,
            controlType: 'dropdown',
            options: [
              { key: 'motor', value: 'Motor' },
              { key: 'property', value: 'Property' }
            ]
          },
          {
            key: 'typeOfInsurance',
            label: 'Type of cover',
            order: 2,
            required: true,
            controlType: 'dropdown',
            options: [
              {
                key: 'thirdPartyAndTheft', value: 'Third Party And Theft', miValue: 1, dependsOn: {
                  key: 'typeOfAsset', value: 'motor'
                }
              },
              {
                key: 'comprehensive', value: 'Comprehensive', miValue: 2, dependsOn: {
                  key: 'typeOfAsset', value: 'motor'
                }
              },
              {
                key: 'thirdPartyOnly', value: 'Third Party Only', miValue: 3, dependsOn: {
                  key: 'typeOfAsset', value: 'motor'
                }
              },
              {
                key: 'others', value: 'Others', miValue: 4, dependsOn: {
                  key: 'typeOfAsset', value: 'motor'
                }
              },
              {
                key: 'fire', value: 'Fire', miValue: 1, dependsOn: {
                  key: 'typeOfAsset', value: 'property'
                }
              },
              {
                key: 'fixture', value: 'Fixture', miValue: 2, dependsOn: {
                  key: 'typeOfAsset', value: 'property'
                }
              },
              {
                key: 'comprehensive', value: 'Comprehensive', miValue: 3, dependsOn: {
                  key: 'typeOfAsset', value: 'property'
                }
              },
              {
                key: 'building', value: 'Building', miValue: 4, dependsOn: {
                  key: 'typeOfAsset', value: 'property'
                }
              },
              {
                key: 'furniture', value: 'Furniture', miValue: 5, dependsOn: {
                  key: 'typeOfAsset', value: 'property'
                }
              },
              {
                key: 'others', value: 'Others', miValue: 6, dependsOn: {
                  key: 'typeOfAsset', value: 'property'
                }
              }
            ]
          },
          {
            key: 'renewableDate',
            label: 'Renewal Date',
            order: 3,
            required: false,
            controlType: 'textbox',
            type: 'date'
          },
          {
            key: 'premium',
            label: 'Premium',
            order: 4,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'medicalExpensesAccident',
            label: 'Medical expenses - Accident',
            order: 5,
            required: false,
            controlType: 'textbox',
            type: 'number',
            dependsOn: {
              key: 'typeOfAsset', value: 'motor'
            }
          },
          {
            key: 'medicalExpensesOther',
            label: 'Medical Expenses - Other',
            order: 6,
            required: false,
            controlType: 'textbox',
            type: 'number',
            dependsOn: {
              key: 'typeOfAsset', value: 'motor'
            }
          },
          {
            key: 'sumInsuredAccidentalPermanentDisablement',
            label: 'Sum Insured - Accidental Permanent disablement',
            order: 7,
            required: false,
            controlType: 'textbox',
            type: 'number',
            dependsOn: {
              key: 'typeOfAsset', value: 'motor'
            }
          },
          {
            key: 'sumInsuredAccidentalDeath',
            label: 'Sum Insured - Accidental Death',
            order: 8,
            required: false,
            controlType: 'textbox',
            type: 'number',
            dependsOn: {
              key: 'typeOfAsset', value: 'motor'
            }
          },
          {
            key: 'address1',
            label: 'Address 1',
            order: 9,
            required: false,
            controlType: 'textbox',
            type: 'text',
            dependsOn: {
              key: 'typeOfAsset', value: 'property'
            }
          },
          {
            key: 'propertyType',
            label: 'Property Type',
            order: 10,
            required: false,
            controlType: 'textbox',
            type: 'text',
            dependsOn: {
              key: 'typeOfAsset', value: 'property'
            }
          },
          {
            key: 'ownerStatus',
            label: 'Owner Status',
            order: 11,
            required: false,
            controlType: 'dropdown',
            options: [
              { key: 'iTenant', value: 'I tenant', miValue: 0 },
              { key: 'iRent', value: 'I rent', miValue: 1 },
              { key: 'iOwn', value: 'I own', miValue: 2 }
            ],
            dependsOn: {
              key: 'typeOfAsset', value: 'property'
            },
            value: 'iTenant'
          },
          {
            key: 'postcode',
            label: 'Postcode',
            order: 12,
            required: false,
            controlType: 'textbox',
            type: 'text',
            dependsOn: {
              key: 'typeOfAsset', value: 'property'
            }
          }
        ],
        policies: []
      },
      {
        key: 'lifeInsurances',
        text: 'Life Insurance(s)',
        subText: '',
        isShownSubText: false,
        actived: false,
        indexOfChosenPolicy: 0,
        newPolicyDefaultOptions: ['typeOfInsurance', 'totalSumInsured', 'renewableDate'],
        addedPolicyDefaultOptions: [
          'typeOfInsurance',
          'totalSumInsured',
          'renewableDate'
        ],
        products: [
          { key: 'termLife', text: 'Term Life', actived: false },
          { key: 'incomeProtection', text: 'Income Protection', actived: false },
          { key: 'longTermCare', text: 'LongTerm Care', actived: false }
        ],
        productCategory: [
          { key: 'lifeInsurance', productKey: 'termLife', value: 'Life Insurance' },
          { key: 'lifeInsurance', productKey: 'incomeProtection', value: 'Life Insurance' },
          { key: 'lifeInsurance', productKey: 'longTermCare', value: 'Life Insurance' }
        ],
        questionRaws: [
          {
            key: 'typeOfInsurance',
            label: 'Type Of Insurance',
            order: 1,
            required: true,
            controlType: 'dropdown',
            options: [
              { key: 'endowment', value: 'Endowment', miValue: 1 },
              { key: 'termLife', value: 'Term Life', miValue: 2 },
              { key: 'wholeLife', value: 'Whole Life', miValue: 3 },
              { key: 'investmentLinked', value: 'Investment Linked', miValue: 4 },
              { key: 'retirement', value: 'Retirement', miValue: 5 },
              { key: 'others', value: 'Others', miValue: 6 }
            ]
          },
          {
            key: 'totalSumInsured',
            label: 'Total Sum Insured',
            order: 2,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'renewableDate',
            label: 'Renewable Date',
            order: 3,
            required: false,
            controlType: 'textbox',
            type: 'date'
          },
          {
            key: 'medicalExpensesAccident',
            label: 'Medical expenses - Accident',
            order: 4,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'medicalExpensesOther',
            label: 'Medical Expenses - Other',
            order: 5,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredAccidentalPermanentDisablement',
            label: 'Sum Insured - Accidental Permanent disablement',
            order: 6,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredAccidentalDeath',
            label: 'Sum Insured - Accidental Death',
            order: 7,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredPermanentDisablementLife',
            label: 'Sum Insured - Accidental Permanent disablement Life',
            order: 8,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredEarlyCriticalIllness',
            label: 'Sum Insured - Early Critical Illness',
            order: 9,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredCriticalIllness',
            label: 'Sum Insured -  Critical Illness',
            order: 10,
            required: false,
            controlType: 'textbox',
            type: 'number'
          },
          {
            key: 'sumInsuredLifeDeath',
            label: 'Sum Insured - Life Death',
            order: 11,
            required: false,
            controlType: 'textbox',
            type: 'number'
          }
        ],
        policies: []
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/coverage.ts